<template>
  <BasePageContent>
    <BasePageHeader
      :sectiontitle="
        (uuid || warehouse) && !Util.isEmpty(Warehouse) ? 'EDIT WAREHOUSE' : ''
      "
      :title="
        (uuid || warehouse) && !Util.isEmpty(Warehouse)
          ? Warehouse.warehouse_name
          : 'New Warehouse'
      "
      :description="
        (uuid || warehouse) && !Util.isEmpty(Warehouse) ? Warehouse.email : ''
      "
    >
      <ul class="nk-block-tools g-1">
        <li v-if="(uuid || warehouse) && !Util.isEmpty(Warehouse)">
          <div class="drodown">
            <a
              href="#"
              class="dropdown-toggle btn btn-white btn-dim btn-outline-light"
              data-toggle="dropdown"
            >
              <em class="icon ni ni-more-h"></em
            ></a>
            <div class="dropdown-menu dropdown-menu-right">
              <ul class="link-list-opt no-bdr">
                <li>
                  <a title="Disable Warehouse" href="#">
                    <em class="dd-indc icon ni ni-copy"></em>
                    <span>Disable Warehouse</span>
                  </a>
                </li>
                <li>
                  <a
                    title="Delete Warehouse"
                    class="w3-text-red w3-hover-text-black"
                    href="#"
                  >
                    <em class="dd-indc icon ni ni-trash"></em>
                    <span> Delete Warehouse</span>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </li>
        <li class="nk-block-tools-opt">
          <a
            class="btn w3-theme w3-hover-theme btn-dim btn-outline-light"
            title="Save Changes"
            href="#"
            @click.prevent="SaveWarehouse"
          >
            <em class="icon ni ni-save"></em>
            <span>Save</span>
          </a>
        </li>
        <li class="nk-block-tools-opt">
          <a href="#" @click.prevent="OnCancel"
            ><em class="icon ni ni-cross size36"></em
          ></a>
        </li>
      </ul>
    </BasePageHeader>
    <div class="p-2 w3-white">
      <template
        v-if="!uuid || ((uuid || warehouse) && !Util.isEmpty(Warehouse))"
      >
        <div v-if="fetching" class="px-3">Loading...</div>
        <form v-else :id="ID" @submit.prevent>
          <div v-if="tabbed" id="tabs" class="mb-4 py-0 w3-border-bottom">
            <button
              v-for="view in Views"
              :key="view"
              @click.prevent="SwitchView(view)"
              class="w3-button px-2 pt-3 w3-hover-transparent"
              :class="[
                ActiveView === view
                  ? 'pb-1 w3-bottombar w3-border-theme'
                  : ' pb-2',
              ]"
            >
              <i
                class="w3-text-theme w3-hover-text-theme"
                :class="ViewsIcons[view]"
              />
              <span class="w3-hide-small ml-1">{{ view }}</span>
            </button>
          </div>
          <div
            v-show="IsActiveView('Contact')"
            class="basicInfo mt-5 w3-animate-opacity"
            :class="[!Tabbed ? 'w3-border-bottom' : '']"
          >
            <div class="row g-2">
              <div class="col-md-4">
                <label for="warehouse_name">Warehouse name</label>
              </div>
              <div class="col-md-8 mb-3">
                <BaseInput
                  id="warehouse_name"
                  v-model="Warehouse.warehouse_name"
                  hint="Name of a business or person."
                />
              </div>
            </div>
            <div class="row g-2">
              <div class="col-md-4">
                <h6>Primary Contact</h6>
              </div>
              <div class="col-md-8 mb-2">
                <div class="row g-2">
                  <div class="col-md-6 mb-2">
                    <BaseInput
                      id="firstname"
                      v-model="Warehouse.firstname"
                      label="First Name"
                      type="text"
                    />
                  </div>
                  <div class="col-md-6 mb-2">
                    <BaseInput
                      id="lastname"
                      v-model="Warehouse.lastname"
                      label="Last Name"
                      type="text"
                    />
                  </div>
                  <div class="col-md-12 mb-2">
                    <BaseInput
                      id="email"
                      v-model="Warehouse.email"
                      label="Email"
                      type="email"
                    />
                  </div>
                  <div class="col-md-6 mb-2">
                    <BaseInput
                      id="telephone"
                      v-model="Warehouse.telephone"
                      label="Telephone"
                      type="text"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            v-show="IsActiveView('Address')"
            class="addressInfo mt-5 w3-animate-opacity"
            :class="[!Tabbed ? 'w3-border-bottom' : '']"
          >
            <div class="row g-2">
              <div class="col-md-4">
                <h6>Address</h6>
              </div>
              <div class="col-md-8 mb-2">
                <div class="row g-2">
                  <div class="col-md-12 mb-2">
                    <BaseInput
                      id="address"
                      v-model="Warehouse.address"
                      label="Street address"
                    />
                  </div>
                  <div class="col-md-12 mb-2">
                    <BaseInput
                      id="city"
                      v-model="Warehouse.city"
                      label="City"
                    />
                  </div>

                  <div class="col-md-6 mb-2">
                    <div class="form-group">
                      <label for="country" class="form-label">Country </label>
                      <select
                        id="country"
                        v-model="Warehouse.country"
                        @change="GetStates"
                        class="form-control form-control-lg select2"
                        data-placeholder="Select country"
                        data-allow-clear="true"
                      >
                        <option
                          v-for="country in Settings._COUNTRIES"
                          :key="country.country_code"
                          :value="country.country_code"
                        >
                          {{ country.country_name }}
                        </option>
                      </select>
                    </div>
                  </div>
                  <div class="col-md-6 mb-2">
                    <div class="form-group">
                      <label for="state" class="form-label">State </label>
                      <select
                        id="state"
                        v-model="Warehouse.state"
                        class="form-control form-control-lg select2"
                        data-placeholder="Select state"
                        data-allow-clear="true"
                      >
                        <option
                          v-for="state in States"
                          :key="state.state_code"
                          :value="state.state_code"
                        >
                          {{ state.state_name }}
                        </option>
                      </select>
                    </div>
                  </div>
                  <div class="col-md-6 mb-2">
                    <BaseInput
                      id="postcode"
                      v-model="Warehouse.postcode"
                      label="Postal/Zip code"
                      type="text"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            v-show="IsActiveView('Others')"
            class="otherInfo mt-5 w3-animate-opacity"
          >
            <div class="row g-2">
              <div class="col-md-4">
                <label for="website">Website</label>
              </div>
              <div class="col-md-8 mb-3">
                <BaseInput
                  id="website"
                  v-model="Warehouse.website"
                  type="text"
                />
              </div>
            </div>
            <div class="row g-2">
              <div class="col-md-4">
                <label for="internal_note">Internal note</label>
              </div>
              <div class="col-md-8 mb-3">
                <BaseInput
                  id="internal_note"
                  v-model="Warehouse.internal_note"
                  type="textarea"
                  class="min-height150"
                  hint="Not entered here will not be visible to your warehouse"
                />
              </div>
            </div>
          </div>
        </form>
      </template>
      <div
        v-else-if="!fetching && (uuid || warehouse) && Util.isEmpty(Warehouse)"
        class="p-5 w3-center"
      >
        <img src="/images/item-not-found.png" class="mb-4" />
        <h4>Warehouse not found</h4>
        <router-link
          :to="{ name: 'warehouses' }"
          class="w3-button w3-white w3-border"
        >
          <span class="">Manage Warehouses</span>
        </router-link>
      </div>
    </div>
  </BasePageContent>
</template>
<script>
import { computed, onMounted, ref, toRef } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import { v4 as uuidv4 } from "uuid";
import { frontendUrl, Util } from "@/helpers/utilities";
import { loadScript } from "vue-plugin-load-script";

export default {
  components: {},
  props: {
    id: {
      type: String,
    },
    uuid: {
      type: String,
    },
    warehouse: {
      type: Object,
    },
    tabbed: {
      type: Boolean,
      default: false,
    },
    cancelText: {
      type: String,
      default: "Back",
    },
  },
  emits: ["oncancel", "onsave"],
  setup(props, { emit }) {
    const store = useStore();
    const router = useRouter();
    const ID = props.id ? props.id : uuidv4();
    const Tabbed = toRef(props, "tabbed");
    const Settings = computed(() => store.getters.settings);
    const $ = window.$;
    const publicPath = frontendUrl;
    const fetching = ref(true);
    const fields = {
      uuid: "",
      user_uuid: "",
      warehouse_name: "",
      firstname: "",
      lastname: "",
      email: "",
      mobile: "",
      telephone: "",
      fax: "",
      website: "",
      internal_note: "",
      address: "",
      city: "",
      state: "",
      country: "",
      postcode: "",
      warehouse_photo: "",
    };
    const Warehouse = ref({});
    const WAREHOUSE = toRef(props, "warehouse");
    const GetWarehouse = async () => {
      Warehouse.value = {};
      if (props.uuid) {
        const _warehouse = await store.dispatch(
          "warehouses/getWarehouse",
          props.uuid
        );
        Warehouse.value = {
          ..._warehouse,
        };
      } else if (WAREHOUSE.value) {
        Warehouse.value = WAREHOUSE.value;
      } else {
        Warehouse.value = fields;
      }
      fetching.value = false;
    };
    GetWarehouse();
    const SaveWarehouse = async () => {
      const response = await store.dispatch(
        "warehouses/updateWarehouse",
        Warehouse.value
      );
      if (response?.status === "success") {
        if (props.uuid) {
          router.push({
            name: "warehouse-detail",
            params: { uuid: props.uuid },
          });
        } else {
          Warehouse.value = { ...fields };
          emit("onsave", Warehouse.value);
        }
      }
    };
    const OnCancel = () => {
      if (props.uuid) {
        router.push({
          name: "warehouse-detail",
          params: { uuid: props.uuid },
        });
      } else {
        Warehouse.value = { ...fields };
        emit("oncancel");
      }
    };
    // TAB VIEWS
    const Views = ["Contact", "Address", "Others"];
    const ViewsIcons = {
      Contact: "fas fa-user-tie",
      Address: "fas fa-credit-card",
      Others: "fas fa-info-circle",
    };
    const ViewsNames = {
      Contact: "Contact",
      Address: "Address",
      Others: "Others Info",
    };
    const ActiveView = ref(Views[0]);
    const IsActiveView = (view) => {
      if (Tabbed.value) {
        return ActiveView.value === view ? true : false;
      }
      return true;
    };
    const Validate = (view) => {
      console.log(view);
      return true;
    };
    const SwitchView = (view) => {
      const newViewIndex = Views.indexOf(view);
      if (ActiveView.value === Views[newViewIndex]) return;
      if (Validate(ActiveView.value)) ActiveView.value = Views[newViewIndex];
    };
    const States = computed(() => store.state.states);
    const GetStates = () => {
      store.dispatch("states", {
        country: Warehouse.value.country,
        state_field: "states",
      });
    };
    GetStates();
    onMounted(() => {
      loadScript(publicPath + "/vendor/jquery/jquery-3.6.0.min.js");
      loadScript(publicPath + "/vendor/select2/js/select2.full.min.js")
        .then(() => {
          const $country = $("#country").select2({
            theme: "bootstrap",
          });
          const $state = $("#state").select2({
            theme: "bootstrap",
          });
          $country
            .on("select2:select", function (e) {
              var data = e.params.data;
              Warehouse.value.country = data.id;
              GetStates();
            })
            .on("select2:unselect", function () {
              store.dispatch("states", {
                country: Warehouse.value.country,
              });
              $country.val(null).trigger("change");
              $state.val(null).trigger("change");
              Warehouse.value.country = "";
              Warehouse.value.state = "";
            });
          $state
            .on("select2:select", function (e) {
              var data = e.params.data;
              Warehouse.value.state = data.id;
            })
            .on("select2:unselect", function () {
              $state.val(null).trigger("change");
              Warehouse.value.state = "";
            });
        })
        .catch((err) => {
          console.log(err);
        });
    });
    return {
      store,
      Settings,
      fetching,
      States,
      GetStates,
      ID,
      Tabbed,
      Warehouse,
      SaveWarehouse,
      OnCancel,
      Views,
      ViewsIcons,
      ViewsNames,
      IsActiveView,
      ActiveView,
      SwitchView,
      Util,
    };
  },
};
</script>